import styled, { css } from 'styled-components';
import { pxToRems, breakpoints } from '@awaze/design-system.utils.react';
export const ClearButtonStyled = styled.button `
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;

  display: block;
  margin: 0;
  padding: ${pxToRems(15)};
  width: ${pxToRems(48)};
  height: 100%;

  background-color: transparent;
  border: none;
  border-radius: 4px;

  line-height: 0;

  cursor: pointer;

  > svg {
    fill: ${({ theme }) => theme.ColorGrey300};
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme.ColorBrandPrimary};
  }
`;
export const DisplayContainerStyled = styled.div `
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  max-width: 100%;
  overflow: hidden;
`;
export const InputCombinedStyled = styled.div `
  min-width: 0;
`;
export const InputFacadeStyled = styled.button `
  ${({ shouldShowClearIcon, isFullWidth }) => css `
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    padding: ${pxToRems(12)}
      ${shouldShowClearIcon ? pxToRems(48) : pxToRems(12)} ${pxToRems(12)}
      ${pxToRems(12)};
    width: ${isFullWidth ? '100%' : 'auto'};
    cursor: pointer;
    border-radius: 4px;
    background-color: transparent;
    border: none;
    text-align: left;
    align-self: stretch;

    &:active,
    &:focus {
      outline: 2px solid ${({ theme }) => theme.ColorThemePrimary400};
      z-index: 1; // ensure full outline visible inside facade group
    }
  `}
`;
export const InputFacadeWrappedStyled = styled.div `
  position: relative;
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: ${({ isFullWidth }) => isFullWidth ? 'space-between' : 'flex-start'};
  width: ${({ isFullWidth }) => (isFullWidth ? '100%' : 'auto')};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.ColorWhiteOpacity100};
`;
export const IconStyled = styled.span `
  line-height: 0;
  margin-right: ${pxToRems(12)};

  @media screen and (min-width: ${breakpoints[0]}px) {
    margin-right: ${pxToRems(8)};
  }

  @media screen and (min-width: ${breakpoints[1]}px) {
    margin-right: ${pxToRems(12)};
  }
`;
export const InputStyled = styled.div `
  color: ${({ theme, hasValue }) => hasValue ? theme.ColorGrey800 : theme.ColorGrey400};
`;
export const LabelStyled = styled.div `
  color: ${({ theme }) => theme.ColorGrey700};
`;
export const TextStyled = styled.span `
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
//# sourceMappingURL=input-facade.styles.js.map